export default __webpack_public_path__ + "static/media/markit-card-mobile.9d2ab896.webp";